import React from 'react';
import { Link } from 'react-router-dom';
import Header from '../../headerone/Main'
import Breadcrumb from '../../Breadcrumb/Main'


function StatementExpenELe() {
    return (
        <>
            <Header />
            <Breadcrumb title="Home" subtitle="Liaison Officers" />
            <section id="services" className="services-area pt-120 pb-90 fix">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="section-title text-center mb-50 wow fadeInDown animated" data-animation="fadeInDown" data-delay=".4s" >
                                <h3>POLICIES</h3>
                            </div>
                        </div>
                    </div>


                    <div className="row"> 
                        <div className="col-lg-6 col-md-6">
                            <h3 className='text-center mb-5'>Anti Ragging</h3>
                            <div className="services-box text-dark ">                 
                               
                                <h4 className="text-dark text-maroon">
                                    <Link className='c-link' target="_blank"  to="/anti-ragging"> Anti Ragging Committee</Link> </h4>                                
                            </div>
                        </div>

                        <div className="col-lg-6 col-md-6">
                            <h3 className='text-center mb-5'>Anti Sexual Harrasment</h3>
                            <div className="services-box text-dark ">

                                <h4 className="text-dark text-maroon">
                                    <Link className='c-link' target="_blank"  to="/internalcomplaintcommittee"> Internal Complaints Committee</Link> </h4>
                            </div>
                        </div>


                    </div>  {/* Row */}


                </div>   {/* container */}

            </section>
        </>  
    )
}

export default StatementExpenELe;
